import { useCallback } from 'react';
import { initLocationState, isLocationState, LocationStateContextType } from 'src/modules/locationStateContext.ts';
import { useLocation, useSearchParams } from 'react-router-dom';
import { LocationState } from 'src/modules/LocationState.ts';

export const useLocationState = (): [LocationState, (state: LocationState) => LocationState] => {
    const { state } : { state: LocationStateContextType['locationState'] } = useLocation();
    const locationState = isLocationState(state) ? state : initLocationState;
    const [searchParams, setSearchParams] = useSearchParams();
    const setState = useCallback((newState: LocationState): LocationState => {
        setSearchParams(searchParams, {
            replace: true,
            state: newState,
        });

        return newState;
    }, [searchParams, setSearchParams]);
    return [locationState, setState];
};
